import { render } from "./LangMenu.vue?vue&type=template&id=5815f316"
import script from "./LangMenu.vue?vue&type=script&lang=js"
export * from "./LangMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__